var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map_china",staticClass:"map_china"})}
var staticRenderFns = []

export { render, staticRenderFns }